// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zrRD","newExpiryDate":"styles_newExpiryDate__3YZKG","footer":"styles_footer__2ukD4"};